export default "__VITE_ASSET__81664a57__"